import qs from "query-string";
// Actions
export const SET_RETURN_URL = "navigation/SET_RETURN_URL";
export const NAVIGATE_TO_MY_ACCOUNT_PAGE =
  "navigation/NAVIGATE_TO_MY_ACCOUNT_PAGE";

// Reducer
const initialState = {
  returnUrl: ""
};

export default function reducer(state = initialState, action = {}) {
  if (action.type === SET_RETURN_URL) {
    return { ...state, returnUrl: action.payload };
  }
  return state;
}

// Action Creators
export const setReturnUrl = returnUrl => ({
  type: SET_RETURN_URL,
  payload: returnUrl
});

export const navigateToMyAccountPage = url => {
  return {
    type: NAVIGATE_TO_MY_ACCOUNT_PAGE,
    payload: url
  };
};

const updatedReturnUrl = returnUrl => {
  const urlObject = new URL(returnUrl);
  const acrValues = urlObject.searchParams.get("acr_values");
  urlObject.searchParams.set(
    "acr_values",
    acrValues ? `google ${acrValues}` : "google"
  );
  urlObject.searchParams.set("auth_type", "google");
  return urlObject.href;
};

export const getGoogleSignupUrl = state => {
  const returnUrl = state.navigation.returnUrl;
  try {
    const { pathname } = new URL(returnUrl);
    const isValid = /^\/authorize\/?$/.test(pathname);
    return isValid
      ? qs.stringifyUrl({
          url: returnUrl,
          query: { connection: "google-oauth2" }
        })
      : updatedReturnUrl(returnUrl);
  } catch (err) {
    return null;
  }
};
